<div
  class="question-panel"
  [class.is-expanded]="isExpanded()"
  (mousedown)="blockDisabledDrag($event)"
  (touchstart)="blockDisabledDrag($event)"
>
  <qai-accordian-panel
    [isExpandable]="true"
    [draggable]="draggable() && !readOnly"
    [initialExpanded]="isExpanded()"
    (expandedChange)="isExpanded.set($event)"
  >
    @if (isEditingTitle) {
      <input
        #titleInput
        accordianTitle
        class="question-title-input"
        [formControl]="titleControl"
        (blur)="stopEditingTitle()"
        (keydown.enter)="handleTitleInputKeydown($event)"
      />
    } @else if (questionTitle) {
      <qai-label accordianTitle kind="secondary" size="medium" weight="bold">{{ questionTitle }}</qai-label>
    } @else {
      <qai-label
        accordianTitle
        class="title-placeholder"
        [class.is-editable]="!readOnly"
        kind="secondary"
        size="medium"
        weight="bold"
        (click)="!readOnly && startEditing()"
      >
        {{ 'simulationBuilder.KNOWLEDGE_CHECK_UNTITLED_QUESTION' | transloco }}
      </qai-label>
    }

    <div accordianControls class="accordian-controls">
      <span class="answer-points-count">
        {{ answerPointsCount }}
        {{ (answerPointsCount === 1 ? 'simulationBuilder.KNOWLEDGE_CHECK_ANSWER_POINT_SINGULAR' : 'simulationBuilder.KNOWLEDGE_CHECK_ANSWER_POINT_PLURAL') | transloco }}
      </span>
      <button type="button" class="icon-btn" (click)="startEditing()" [disabled]="readOnly">
        <qai-icon kind="pencil-edit" [color]="'var(--button-primary-bg-default)'" [size]="'16px'" />
      </button>
      <button type="button" class="icon-btn" (click)="deleteRequested.emit()" [disabled]="readOnly || deleting()">
        <qai-icon kind="trash" [color]="'var(--button-primary-bg-default)'" [size]="'16px'" />
      </button>
    </div>

    <div accordianContent>
      <knowledge-check-question-fields [questionForm]="questionForm()" />
      <knowledge-check-answer-points
        [questionForm]="questionForm()"
        [listId]="answerPointListId()"
        [connectedTo]="connectedAnswerPointListIds()"
        (answerPointsReordered)="answerPointsReordered.emit($event)"
      />
    </div>
  </qai-accordian-panel>

  @if (dragHandle() && !draggable() && !readOnly) {
    <qai-tooltip [qaiFloating]="dragHandle()!" [placement]="'above-start'" [events]="['hover']">
      {{ 'simulationBuilder.KNOWLEDGE_CHECK_REORDER_DISABLED_TOOLTIP' | transloco }}
    </qai-tooltip>
  }
</div>
